import { useContext } from "@nuxtjs/composition-api";
function useFetchProducts() {
  const { $api } = useContext();
  const fetchProductsAll = async (params) => {
    try {
      const { data, meta } = await $api.productsService.getAllProducts(
        params
      );
      return { data, meta };
    } catch (e) {
      console.error("Fetch products failed: ", e);
    }
  };
  const fetchProductBySlug = async (slug, params) => {
    try {
      const { data } = await $api.productsService.getProductBySlug(
        slug,
        params
      );
      return data;
    } catch (e) {
      console.error("Fetch product failed: ", e);
    }
  };
  const fetchProductsByIds = async (productIds, params = {}) => {
    try {
      const response = await $api.productsService.getAllProducts({
        ...params,
        ...{
          search: `id:${productIds.map((id) => `${id}`).join(",")}`,
          searchFields: "id:in",
          limit: 0
        }
      });
      return response?.data;
    } catch (e) {
      console.error("Fetch products failed: ", e);
    }
  };
  const fetchProductsByName = async (queryName, params = {}) => {
    try {
      const { data, meta } = await $api.productsService.getAllProducts({
        ...params,
        ...{
          search: `name:${queryName};sku:${queryName}`,
          searchFields: "name:ilike;sku:ilike",
          orderBy: "name"
        }
      });
      return { data, meta };
    } catch (e) {
      console.error("Fetch products failed: ", e);
    }
  };
  return {
    fetchProductsAll,
    fetchProductsByIds,
    fetchProductBySlug,
    fetchProductsByName
  };
}
var useFetchProducts_default = useFetchProducts;
export {
  useFetchProducts_default as default
};
